/**
 * The signed-in user's id, read from the session token itself. The Descope SDK's `claims` are not
 * always populated (depending on how the session was established), but the session JWT always carries
 * `sub`. Unverified by design: it only keys per-user client state — the server authorizes every
 * request from the token it verifies.
 */
export function sessionSubject(sessionToken) {
    const payload = sessionToken?.split('.')[1];
    if (!payload)
        return undefined;
    try {
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(payload.length / 4) * 4, '='));
        const sub = JSON.parse(json).sub;
        return typeof sub === 'string' && sub.length > 0 ? sub : undefined;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=sessionSubject.js.map